import { observable, action, configure, runInAction, makeObservable } from "mobx";
import CurrentRecallModel from "./models/CurrentRecallModel";
import * as Request from "superagent";
import VehicleRecallModel from "./models/VehicleRecallModel";
import StepNav from "../StepNav";
const allRecallApiUrl = "/proxy/vehicle-recalls/";

configure({ enforceActions: "always" });
export default class AllRecallStore {
  constructor() {
    makeObservable(this);
  }
  @observable currentRecalls?: CurrentRecallModel = new CurrentRecallModel();
  @observable vehicleRecall?: VehicleRecallModel = new VehicleRecallModel();
  stepNav: StepNav;

  @action getCurrentRecalls = () => {
    let url = `${allRecallApiUrl}recall-campaigns/all`;
    Request.get(url).then(
      (response) => {
        runInAction(() => {
          this.currentRecalls.response = response.body;
          console.log(this.currentRecalls.response);
        });
      },
      (error) => {
        runInAction(() => {
          this.currentRecalls.isContentExist = false;
        });
      }
    );
  };

  @action findCarByVin = (vin) => {
    let url = `${allRecallApiUrl}all-recalls/${vin}`;
    Request.get(url).then(
      (response) => {
        runInAction(() => {
          if (response.body != null) {
            this.vehicleRecall.isRecallExist = true;
            this.vehicleRecall.isRequestError = false;
            this.vehicleRecall.RequestErrorStatusCode = response.status;
            this.vehicleRecall.response = response.body;
          } else {
            this.vehicleRecall.isRequestError = true;
            this.vehicleRecall.RequestErrorStatusCode = response.status;
          }
          this.stepNav.navigate();
        });
      },
      (error) => {
        runInAction(() => {
          if (error.status == 404) {
            this.vehicleRecall.isRequestError = true;
            this.vehicleRecall.RequestErrorStatusCode = error.status;
          } else {
            this.vehicleRecall.isRequestError = true;
            this.vehicleRecall.RequestErrorStatusCode = error.status;
          }
          this.stepNav.navigate();
        });
      }
    );

    return false;
  };
}
